<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Tax Status</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :footer-props="footerProps"
        :loading="loading"
      >
        <template v-slot:item.actions="{item}">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
const API_ENDPOINT = "/api/taxStatus/pme";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    },
    param: {
      type:String,
      default: ""
    }
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "taxCode",
        sortable: true
      },
      {
        text: "Description",
        value: "taxDesc",
        sortable: true
      }
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50]
    }
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}?param=${this.param ?? ''}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAll();
  }
};
</script>
<style scoped>
.inactive {
  background-color: rebeccapurple;
}
</style>